import React from 'react';

import { AdditionalInfo } from '~/components/ContractDetails/AdditionalInfo';

import { ContractSubViewHeader } from '../components/ContractSubViewHeader';

type ContractAdditionalInfoViewProps = {
  contractId: string;
  // eslint-disable-next-line react/no-unused-prop-types
  contractIds: string[];
  // eslint-disable-next-line react/no-unused-prop-types
  loading: boolean;
  contractDetails: any;
  onBack: () => void;
  // eslint-disable-next-line react/no-unused-prop-types
  onContractChange: (id: string) => void;
};

export function ContractAdditionalInfoView({ contractId, contractDetails, onBack }: ContractAdditionalInfoViewProps) {
  return (
    <div>
      <ContractSubViewHeader contractId={contractId} onBack={onBack} />
      <AdditionalInfo person={contractDetails?.person} />
    </div>
  );
}
